var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticStyle:{"height":"100%","width":"100%"}},[_c('el-header',{staticClass:"nav-container"},[_c('navbar',{attrs:{"navItems":_vm.navItems,"main-route":_vm.mainRoute},on:{"reload":_vm.reload}},[_vm._t("header")],2)],1),_c('el-container',[_c('el-main',[(_vm.isAlive)?_c('router-view'):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }